export default {
  menu: 'Sale Refunds',
  title: 'Sale Refunds',

  general: {
    labels: {
      user: 'Customer',
      id: 'Invoice ID',
      sourceInvoice: 'Source',
      date: 'Registration date',
      store: 'Store',
      sourceQuantity: 'Source quantity',
      status: 'Status'
    },

    placeholders: {
      id: 'Automatic'
    },

    status: {
      all: 'All',
      preInvoice: 'Draft',
      invoice: 'Invoice',
      storeReceived: 'Pull in',
      incomplete: 'Incomplete',
      deleted: 'Deleted',
      voided: 'Voided'
    },

    actionTypes: {
      present: 'Retail',
      tel: 'Telephone',
      internet: 'Internet'
    },

    notifications: {
      document: {
        success: 'Invoice document successfully registered',
        error: 'The registration of the invoice document was accompanied by an error',
        isExist: 'Invoice document registered'
      },

      insert: {
        success: 'Sales refund invoice successfully registered',
        error: 'Registration of sales refund invoice was accompanied by an error!'
      },

      edit: {
        success: 'Sale refund invoice successfully edited',
        error: 'Editing the refund sale invoice was accompanied by an error!'
      },

      delete: {
        success: 'Sale invoice successfully deleted',
        error: 'Delete sale invoice has error'
      },

      restore: {
        success: 'Invoice successfully restored',
        error: 'Restore  refund sale invoice was accompanied by an error'
      },

      refreshStatus: {
        success: 'Invoice status returned successfully',
        error: 'Invert invoice status returned failed'
      },

      parseError: {
        user: 'Supplier not selected!',
        lines: 'No items selected!',
        store: 'Warehouse not selected!',
        unitPrice: 'The amount of the goods has not been entered!',
        invoiceNumber: 'This invoice number is already selected!',
        count: 'The number of selected products is not valid!',
        quantity: 'Inventory is not enough!',
        dynamicQuantity: '{name} set refund and can\'t refund it again!'
      }
    },

    confirmations: {
      delete: {
        title: 'Confirmation delete the refunded sales invoice',
        body: 'In case of deleting the refunded sales invoice, all documents and warehouse transfers related to the invoice will be deleted. are you sure?'
      },
      forceDelete: {
        title: 'Confirmation of deletion refund sale invoice',
        body: 'If the refund sales invoice is deleted, the information of invoice deleted and cant restore it. Are you sure? '
      },
      forceUpdate: {
        title: 'Refund sale invoice edit confirmation',
        body: 'By edit refund sale invoice, All documents related to this invoice change. Are you sure of confirming edit return sale invoice?',
        taxNumberBody: 'By edit sale invoice, All documents related to this invoice change. {danger} Are you sure of confirming edit sale invoice? ',
        taxNumberBodyDanger: 'This invoice has tax number!'
      }
    }
  },

  list: {
    title: 'Sale Refunds',

    table: {
      header: {
        id: 'Number',
        reference: 'Reference',
        creator: 'Creator',
        user: 'Customer',
        country: 'Country',
        province: 'Province',
        date: 'Date',
        totalPrice: 'Amount',
        totalDiscount: 'Discount',
        totalVat: 'Vat',
        shipping: 'Shipping',
        finalPrice: 'Net Amt',
        type: 'Type',
        status: 'Status',
        score: 'Point',
        lastModifiedDate: 'Update',
        restore: 'Restore',
        delete: 'Delete'
      },

      filters: {
        type: {
          all: 'All',
          present: 'Retail',
          tel: 'Telephone',
          internet: 'Internet'
        }
      }
    }
  },

  insert: {
    title: 'Create New Sale Refunds',

    typeTitle: {
      present: 'Add retail sales refund invoice',
      tel: 'Add telephone sales refund invoice',
      internet: 'Add internet sales refund invoice'
    }
  },

  invoice: {
    title: 'Sale Refund Invoice',
    dynamicTitle: '{type} Sale Refund {pre} Invoice No. {id}',
    dynamicTitleWithoutId: '{type} Sale Refund Invoice ',

    general: {
      table: {
        header: {
          rowNumber: 'Row',
          code: 'Barcode',
          barcode: 'Barcode',
          name: 'Product',
          description: 'Description',
          variant: 'Variable',
          tax: 'Vat Amount',
          taxRate: 'Vat',
          discount: 'Discount',
          unitDiscount: 'Unit Disc.',
          store: 'Store',
          count: 'Qty',
          unitPrice: 'Unit price',
          netUnit: 'Net unit',
          netUnitTaxable: 'Net taxable',
          subTotal: 'Amount',
          totals: 'Totals',
          totalPrice: 'Amount',
          delete: 'Delete'
        }
      }
    },

    logs: {
      title: 'Sale Refund Invoice Logs'
    },

    print: {
      title: 'Sale refund invoice',
      preInvoice: 'Draft refund',
      taxInvoice: 'Tax refund invoice '
    }
  },

  edit: {
    title: 'Edit sale Refund invoice',

    typeTitle: {
      present: 'Edit retail sale refund invoice',
      tel: 'Edit telephone sale refund invoice',
      internet: 'Edit internet sale refund invoice'
    }
  },

  trash: {
    title: 'Return sale invoice trash'
  },

  refreshStatus: {
    title: 'Return sales invoice status',

    labels: {
      description: 'Note that if the invoice status is returned, all documents and delivery note related to each status will be deleted',
      accept: 'Confirm',
      cancel: 'Cancel'
    }
  }
}
